<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/awTbS5/tc-custom/9781250101235.jpg?1725275569619" alt="This image is the cover for the book Best Intentions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best Intentions
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“<i>Best Intentions</i> is that rare novel that grows more gripping and emotionally rich with every turn of the page.” —Carla Buckley</b><br/><br/>Marti Trailor—social worker on hold, mother of three, wife of a successful obstetrician, daughter of a Congressman—is ready to go back to work. She’s thrilled when the perfect opportunity falls in her lap. The catch? The job is at her husband's hospital and he seems not to share her enthusiasm. Undeterred, she takes the position counseling vulnerable young women as they prepare to give birth.<br/><br/>Marti quickly begins to feel like she is making a difference in the lives of her clients. Soon, though, she finds herself caught up in the dark side of the medical center—with its long hours, overworked doctors and entrenched practices. When she witnesses something she can't unsee, Marti, who has always done her best to keep a low-profile, finds herself thrust under a dangerous spotlight with all of Richmond, Virginia watching.<br/><br/>In her captivating domestic suspense novel <i>Best Intentions</i>, Erika Raskin weaves together high stakes hospital politics, the pressures of family life, and the consequences of trying to do the right thing, particularly in a city with a history as fraught as Richmond's.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erika Raskin
      </h2>
      
      <p class="authorDescription body article">ERIKA RASKIN is a writer from Charlottesville, Virginia. A mother and (young) grandmother, she’s married to a doctor. Her first novel, <I>Close</I>, came out in 2014.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c819ca5